import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Directive, HostBinding, Input, NgModule } from '@angular/core';
import { CoerceBooleanVariant } from '@slidebean/hydra/coercion';
import { css, compoundVariants, Styled } from '@slidebean/kappa';

function compound(active, tone) {
    let styles = {};
    if (tone === 'none') {
        styles = {
            color: '$neutral-foreground',
            '&:hover': {
                borderColor: '$primary-solid',
                backgroundColor: '$primary-subtle',
            },
            '&:active': {
                borderColor: '$primary-solid-active',
                backgroundColor: '$primary-subtle-active',
            },
        };
        if (active) {
            styles['borderColor'] = '$primary-solid';
            styles['backgroundColor'] = '$primary-subtle';
        }
        return {
            active,
            tone,
            css: styles,
        };
    }
    styles = {
        color: `$${tone}-foreground`,
        '&:hover': {
            borderColor: `$${tone}-solid`,
            backgroundColor: `$${tone}-subtle`,
        },
        '&:active': {
            borderColor: `$${tone}-solid-active`,
            backgroundColor: `$${tone}-subtle-active`,
        },
    };
    if (active) {
        styles['borderColor'] = `$${tone}-solid`;
        styles['backgroundColor'] = `$${tone}-subtle`;
    }
    return {
        active,
        tone,
        css: styles,
    };
}
const $SlidePropertiesButton = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '$pill',
    background: '$panel',
    border: '$borderWidths$thick solid $border',
    transitionDuration: '200ms',
    transitionTimingFunction: 'ease',
    transitionProperty: 'border-color, color, background-color',
    '&:focus': { outline: 'none' },
    '&:disabled, &[disabled]': {
        pointerEvents: 'none',
        cursor: 'not-allowed',
        opacity: 0.4,
    },
    variants: {
        active: {
            true: {},
            false: {},
        },
        pill: {
            true: {
                px: '$medium',
            },
        },
        tone: {
            none: {},
            neutral: {},
            primary: {},
            danger: {},
            warning: {},
            success: {},
        },
        size: {
            small: { minSize: '$8' },
            medium: { minSize: '$12' },
            large: { minSize: '$16' },
        },
    },
    compoundVariants: compoundVariants(compound, [true, false], ['primary', 'neutral', 'success', 'warning', 'danger', 'none']),
    defaultVariants: {
        tone: 'none',
        size: 'medium',
        active: false,
    },
});
let SlidePropertiesButtonDirective = class SlidePropertiesButtonDirective {
    constructor() {
        this.tone = 'none';
        this.size = 'medium';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: SlidePropertiesButtonDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.10", type: SlidePropertiesButtonDirective, selector: "button[sb-slide-properties-button]", inputs: { active: "active", pill: "pill", tone: "tone", size: "size" }, host: { properties: { "class": "this.class" } }, ngImport: i0 }); }
};
__decorate([
    CoerceBooleanVariant()
], SlidePropertiesButtonDirective.prototype, "active", void 0);
__decorate([
    CoerceBooleanVariant()
], SlidePropertiesButtonDirective.prototype, "pill", void 0);
SlidePropertiesButtonDirective = __decorate([
    Styled($SlidePropertiesButton)
], SlidePropertiesButtonDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: SlidePropertiesButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[sb-slide-properties-button]',
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], active: [{
                type: Input
            }], pill: [{
                type: Input
            }], tone: [{
                type: Input
            }], size: [{
                type: Input
            }] } });
class SlidePropertiesButtonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: SlidePropertiesButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: SlidePropertiesButtonModule, declarations: [SlidePropertiesButtonDirective], exports: [SlidePropertiesButtonDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: SlidePropertiesButtonModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: SlidePropertiesButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [SlidePropertiesButtonDirective],
                    declarations: [SlidePropertiesButtonDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SlidePropertiesButtonDirective, SlidePropertiesButtonModule };
